import { InjectionToken } from '@angular/core';

/** Static header name for public key exchange */
export const PUBLIC_KEY_HEADER_NAME = 'X-Client-Init';

/** Security library configuration */
export interface SecurityConfig {
  /** Master switch: true = fetch key + encrypt/decrypt, false = bypass all (default: true) */
  enableEncryption?: boolean;

  /** Full public key endpoint URL (required if enableEncryption is true) */
  publicKeyEndpoint?: string;

  /** Expected SHA-256 hash for public key pinning (MITM protection) */
  expectedPublicKeyHash?: string;

  /** Endpoint patterns to encrypt: ['*'] = all, ['/api/*'] = glob, ['/exact/path'] = exact (default: ['*']) */
  encryptDecryptForEndpoints?: string[];

  /** Endpoint patterns to skip encryption (higher priority than encryptDecryptForEndpoints) */
  skipEncryptDecryptForEndpoints?: string[];

  /** Enable debug logging (default: true) */
  enableDebugLogging?: boolean;

  /** Retry attempts for public key fetch (default: 3) */
  publicKeyFetchRetries?: number;
}

/** Injection token for security config */
export const SECURITY_CONFIG = new InjectionToken<SecurityConfig>('SecurityConfig');

/** Default configuration */
export const DEFAULT_SECURITY_CONFIG: SecurityConfig = {
  publicKeyEndpoint: 'http://localhost:8080/v1/crypto/init',
  expectedPublicKeyHash: 'f2a9e8cc00a20dc3398d0b370e0853aa6d5df3e5b943ce00008fd2ec8a0c8b5b',
  encryptDecryptForEndpoints: ['*'],
  enableDebugLogging: true,
  enableEncryption: true,
  publicKeyFetchRetries: 3
};
